export default __webpack_public_path__ + "static/media/it900-a031-en.aa04bbc4.jpg";